import { Button } from '@stratascratch/ui'

interface Props {
  tests: Test[] | undefined
  selectedTest: Test
  setSelectedTest: (test: Test) => void
}

export interface Test {
  id: string
  input: string
  public: boolean
}

function TestTabs({ tests, selectedTest, setSelectedTest }: Props) {
  if (!tests || tests.length === 0) return null

  return (
    <div className="mt-4 basis-full">
      <div className="mb-4 flex gap-2">
        {tests.map((test, i) => (
          <Button
            key={test.id}
            type="button"
            variant={test.id === selectedTest.id ? 'primary' : 'outline'}
            size="rectangle"
            className="!min-w-auto px-2"
            onClick={() => {
              setSelectedTest(test)
            }}
          >
            Test {i + 1}
          </Button>
        ))}
      </div>
      <textarea
        className="TestTabs__textarea border-(--color-border) w-full rounded-md border-2 p-2"
        value={selectedTest.input}
        disabled
        readOnly
      />
    </div>
  )
}

export default TestTabs
